/* eslint react-hooks/exhaustive-deps: "warn" */
import { useInt } from 'hooks/useInt';

import { CaseStudyCard } from 'landing-pages/shared/CaseStudyCard/CaseStudyCard';

export const MdmTestimonial = () => {
  const { t } = useInt();

  return (
    <CaseStudyCard
      company="Statista"
      title={t('How Statista Enriches Its Company Data Product')}
      summary={t(
        'Statista scales its own B2B company intelligence product on data sourced directly from official government registries — a master dataset it can trust as the single source of truth downstream.',
      )}
      href="/how-statista-enriches-its-company-data-product-with-global-database"
    />
  );
};
